/**
 * Sauce for Strava™ — analytics overlay for Strava
 *
 * Declares one web-accessible-resource entry — `build.json` plus the globs
 * `src/*`, `images/*`, `css/*` and others — matched only to
 * `https://www.strava.com/*`, with no `use_dynamic_url`. The files are static
 * and fetchable at a fixed URL, but only from Strava, since no other origin is
 * in the `matches`.
 *
 * So Sauce is detectable, yet only by strava.com. Anywhere else the resources
 * are unreachable and a negative result proves nothing.
 *
 * Manifest verified against version 8.10.1.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'eigiefcapdcdmncdghkeahgfmnobigha';

export const sauceForStrava: ExtensionDefinition = {
  id: ID,
  name: 'Sauce for Strava™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 50_000,
  requiredOrigin: 'https://www.strava.com',
  notes:
    'Static WAR (build.json, images/*) scoped to www.strava.com. Only that ' +
    'origin can detect it; conclusive there.',
  signals: [
    {
      id: 'war-build-json',
      kind: 'web-accessible-resource',
      description:
        'Fetch build.json — an explicitly listed static resource, exposed only to ' +
        'www.strava.com.',
      weight: 1,
      run: () => probeFetch(ID, 'build.json'),
    },
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load images/icon128.png via <img> — corroborates without needing a CORS grant, ' +
        'still origin-scoped to Strava.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/icon128.png'),
    },
  ],
};
